import _find from 'lodash/find';
import _debounce from 'lodash/debounce';
import get from 'lodash/get';

import registerStudentTemplate from './register-student/register-student.html';
import unregisterStudentTemplate from './unregister-student/unregister-student.html';
import editAttendanceTemplate from './../attendances/edit-attendance/edit-attendance.html';
import studentInfoTemplate from './student-info/student-info.html';
import {PinRegistrationController} from '../../components/pin-registration/pin-registration.component';
import pinRegistrationTemplate from '../../components/pin-registration/pin-registration.html';
import {AuthorizedOutsidePersonController} from './authorized-outside-person/authorized-outside-person.component';
import authorizedOutsidePersonTemplate from './authorized-outside-person/authorized-outside-person.html';
import template from './dashboard.html';

class DashboardComponent {
  /** @ngInject */
  constructor(
    $rootScope, $log, $state, $mdDialog, $mdToast, $mdSidenav, $document, $interval, moment,
    GroupService,
    StudentService,
    ClassRoomService,
    AttendanceService,
    CategoryOfDepartureService,
    UtilService,
    MdtSelectionStore
  ) {
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$mdSidenav = $mdSidenav;
    this.$document = $document;
    this.$interval = $interval;
    this.moment = moment;
    this.GroupService = GroupService;
    this.StudentService = StudentService;
    this.ClassRoomService = ClassRoomService;
    this.CategoryOfDepartureService = CategoryOfDepartureService;
    this.AttendanceService = AttendanceService;
    this.hasAccessToProximityCardReader = $rootScope.me.schoolConfiguration.hasAccessToProximityCardReader;
    this.groups = [];
    this.unregisterStudents = [];
    this.selectedUnregisterGroupId = 0;
    this.selectedUnregisterTagId = 0;
    this.selectedRegisterGroupId = 0;
    this.selectedRegisterTagId = 0;
    this.selectedRegisterIDs = [];
    this.selectedAllRegisterIDs = [];
    this.selectedUnregisterIDs = [];
    this.parentElement = angular.element(this.$document[0].querySelector('#app-body'));
    this.registerStudentsList = [];
    this.attendanceRegistrations = [];
    this.allAttendanceRegistrations = [];
    this.openHistoryAttendaces = false;
    this.selected = [];
    this.loadPageCallbackWithDebounce = {};
    this.allStudents = false;
    this.weekdaysMap = UtilService.getWeekDaysMap();
    this.MdtSelectionStore = MdtSelectionStore;
  }

  $onInit() {
    this.getStudents();
    this.GroupService.getAllGroups().then(result => {
      this.groups = result;
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać grup')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
    this.unregisterStudentsInterval = this.$interval(() => {
      this.loadPageCallbackWithDebounce();
    }, 180000);

    this.loadAllAttendances();

    this.attendanceRegistrationsInterval = this.$interval(() => {
      this.loadAttendanceRegistration({showLoaderSpinner: false});
    }, 180000);

    this.$rootScope.$on('component.waiting-students.register-student', () => {
      this.loadAllAttendances();
      this.getWaitingStudentsNumber().then(value => {
        this.waitingStudentsNumber = value;
      });
    });

    this.$rootScope.$on('controller.new-student.add', () => {
      this.loadAllAttendances();
    });

    this.$rootScope.$on('dashboard.config.studentIsRegistered', () => {
      this.loadAllAttendances();
      this.loadPageCallbackWithDebounce();
    });

    this.$rootScope.$on('dashboard.config.unregister', () => {
      this.loadAllAttendances();
      this.loadPageCallbackWithDebounce();
    });

    this.getWaitingStudentsNumber().then(value => {
      this.waitingStudentsNumber = value;
    });
  }

  $onChanges(changes) {
    if (changes.currentClassRoom) {
      this.currentClassRoom = {...this.currentClassRoom};
    }

    if (changes.access) {
      this.access = {...this.access};
    }

    if (changes.classRooms) {
      this.classRooms = Object.assign([], this.classRooms);
    }

    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.tags) {
      this.tags = {...this.tags};
    }
  }

  $onDestroy() {
    this.$interval.cancel(this.unregisterStudentsInterval);
    this.$interval.cancel(this.attendanceRegistrationsInterval);
    if (this.attendanceAllRegistrationsInterval) {
      this.$interval.cancel(this.attendanceAllRegistrationsInterval);
    }
  }

  getClassRoomName(id) {
    return this.ClassRoomService.getClassRoomName(id);
  }

  changeFilterName() {
    if (this.loadPageCallbackWithDebounce) {
      this.loadPageCallbackWithDebounce();
    }
  }

  getStudents() {
    this.promise = this.StudentService.getForRegistration({classRoomId: this.currentClassRoom.id}).then(result => {
      this.students = result;
    });
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  getWaitingStudentsNumber() {
    return this.StudentService.getWaitingStudents({showLoaderSpinner: false}).then(result => result.length || 0);
  }

  paginatorCallback(page, pageSize, options = {}) {
    this.isUnregisterLoading = true;
    if (angular.isUndefined(page)) {
      page = 1;
    }

    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    const query = this.filterName ? this.filterName : null;
    let id = options.groupId;
    let {tagId} = options;
    if (angular.isDefined(this.selectedUnregisterGroupId) && this.selectedUnregisterGroupId > 0) {
      id = this.selectedUnregisterGroupId;
    }

    if (angular.isDefined(this.selectedUnregisterTagId) && this.selectedUnregisterTagId > 0) {
      tagId = this.selectedUnregisterTagId;
    }

    return this.StudentService.getForRegistration({
      groupId: id,
      tagId,
      offset,
      limit: pageSize,
      query,
      classRoomId: this.currentClassRoom.id,
      showLoaderSpinner: options.showLoaderSpinner
    }).then(result => {
      this.unregisterStudents = result.data.students;
      return {
        results: result.data.students,
        totalResultCount: result.data.total
      };
    }).finally(() => {
      this.isUnregisterLoading = false;
    });
  }

  loadUnregisterStudents(options = {}) {
    let id = options.groupId;
    if (angular.isDefined(this.selectedUnregisterGroupId) && this.selectedUnregisterGroupId > 0) {
      id = this.selectedUnregisterGroupId;
    }

    this.StudentService.getForRegistration({
      groupId: id,
      classRoomId: this.currentClassRoom.id,
      showLoaderSpinner: options.showLoaderSpinner
    }).then(result => {
      this.unregisterStudents = result;
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać uczniów z grupy')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  prepareAttendancesToDisplay(attendances) {
    attendances.forEach(attendance => {
      attendance.student.permissionsScheduleToDisplay = [];
      if (attendance.student.isPermittedToLeaveOnOwn) {
        const daysWithoutPermissionToLeaveOwn = Object.keys(attendance.student.permissionsSchedule).filter(dayKey => attendance.student.permissionsSchedule[dayKey].type === 'no');
        if (daysWithoutPermissionToLeaveOwn.length === 7) {
          attendance.student.isPermittedToLeaveOnOwn = false;
          return attendance;
        }

        Object.keys(attendance.student.permissionsSchedule).forEach(dayKey => {
          if (attendance.student.permissionsSchedule[dayKey].type !== 'no') {
            attendance.student.permissionsScheduleToDisplay.push({
              name: this.weekdaysMap[dayKey],
              value: attendance.student.permissionsSchedule[dayKey].type === 'specific_hour' ? attendance.student.permissionsSchedule[dayKey].hour : 'cały dzień'
            });
          }
        });
      }
    });
    return attendances;
  }

  loadAttendanceRegistration(options = {}) {
    this.isAttendanceLoading = true;
    let id = options.groupId;
    let {tagId} = options;
    if (angular.isDefined(this.selectedRegisterGroupId) && this.selectedRegisterGroupId > 0) {
      id = this.selectedRegisterGroupId;
    }

    if (angular.isDefined(this.selectedRegisterTagId) && this.selectedRegisterTagId > 0) {
      tagId = this.selectedRegisterTagId;
    }

    this.AttendanceService.getRegistrations({
      employeeId: this.me.employeeId,
      groupId: id,
      tagId,
      classRoomId: this.currentClassRoom.id,
      showLoaderSpinner: options.showLoaderSpinner
    }).then(result => {
      this.attendanceRegistrations = this.prepareAttendancesToDisplay(result);
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać rejestracji')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .finally(() => {
        this.isAttendanceLoading = false;
      });
  }

  loadAllAttendanceRegistration(options = {}) {
    this.isAllAttendanceLoading = true;
    let id = options.groupId;
    let {tagId} = options;
    if (angular.isDefined(this.selectedRegisterGroupId) && this.selectedRegisterGroupId > 0) {
      id = this.selectedRegisterGroupId;
    }

    if (angular.isDefined(this.selectedRegisterTagId) && this.selectedRegisterTagId > 0) {
      tagId = this.selectedRegisterTagId;
    }

    this.AttendanceService.getRegistrations({
      groupId: id,
      tagId,
      classRoomId: this.currentClassRoom.id,
      showLoaderSpinner: options.showLoaderSpinner
    }).then(result => {
      this.allAttendanceRegistrations = this.prepareAttendancesToDisplay(result).map(item => {
        item.classRoomName = this.getClassRoomName(item.classRoomId);
        return item;
      });
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać rejestracji')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .finally(() => {
        this.isAllAttendanceLoading = false;
      });
  }
  /*
   * Register students function
   * @param ids {Array}
   * @param ev {Object}
   */

  registerStudents(ids, ev) {
    let i = 0;
    let student = {};
    const students = [];
    const max = ids.length;
    for (i = 0; i < max; i += 1) {
      student = this.getStudentById(this.unregisterStudents, ids[i]);
      if (student) {
        students.push(student);
      }
    }

    this.openRegisterStudentDialog(students, ev);
  }

  /*
   * Unregister students function
   * @param ids {Array}
   * @param ev {Object}
   */

  closeAttendance(ids, ev, params = {}) {
    const attendances = [];
    ids.forEach(id => {
      attendances.push(_find(this.allAttendanceRegistrations, item => item.id === id));
    });
    this.openCloseAttendanceDialog(attendances, ev, params);
  }

  editAttendance(id, ev) {
    let attendance = {};
    attendance = _find(this.attendanceRegistrations, item => item.id === id);
    this.openEditAttendanceDialog(attendance, ev);
  }

  /*
   * Open register students dialog
   * @param students {Array}
   * @param ev {Object}
   */

  openRegisterStudentDialog(students, ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'RegisterStudentController',
      locals: {
        students,
        currentClassRoom: this.currentClassRoom,
        access: this.access,
        classRooms: this.classRooms
      },
      template: registerStudentTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(() => {
        this.selectedUnregisterIDs = [];
        this.MdtSelectionStore.clear('unregisterStudents');
        this.loadPageCallbackWithDebounce();
        this.loadAllAttendances();
      });
  }

  /*
   * Open unregister students dialog
   * @param students {Array}
   * @param ev {Object}
   */

  openCloseAttendanceDialog(attendances, ev, params) {
    const {departureCategory = 1, comment = ''} = params;
    this.CategoryOfDepartureService.getAll().then(categoriesOfDeparture => {
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'UnregisterStudentController',
        locals: {
          attendances,
          categoriesOfDeparture,
          departureCategory,
          comment
        },
        template: unregisterStudentTemplate,
        disableParentScroll: true,
        clickOutsideToClose: true,
        targetEvent: ev
      })
        .then(attendance => {
          this.selectedRegisterIDs = [];
          this.MdtSelectionStore.clear('attendanceRegistrations');
          this.selectedAllRegisterIDs = [];
          this.MdtSelectionStore.clear('allAttendanceRegistrations');
          this.loadPageCallbackWithDebounce();
          this.loadAllAttendances();
          this.getWaitingStudentsNumber().then(value => {
            this.waitingStudentsNumber = value;
          });
          this.$rootScope.$broadcast('component.dashboard.close-attendance', attendance);
        });
    });
  }

  openEditAttendanceDialog(attendance, ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditAttendanceController',
      locals: {attendance},
      template: editAttendanceTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(() => {
        this.loadAllAttendances();
      });
  }

  loadAllAttendances() {
    this.loadAttendanceRegistration();
    this.loadAllAttendanceRegistration();
  }

  /*
   * Selected row callback - function trigger after row selected
   * @param rowsIds {Array}
   */

  selectedRegisterRowCallback(rowsIds) {
    if (this.isAttendanceLoading && (!rowsIds || rowsIds.length === 0)) {
      return;
    }

    this.selectedRegisterIDs = rowsIds;
    this.MdtSelectionStore.set('attendanceRegistrations', rowsIds);
  }

  selectedAllRegisterCallback(rowsIds) {
    if (this.isAllAttendanceLoading && (!rowsIds || rowsIds.length === 0)) {
      return;
    }

    this.selectedAllRegisterIDs = rowsIds;
    this.MdtSelectionStore.set('allAttendanceRegistrations', rowsIds);
  }

  selectedUnregisterRowCallback(rowsIds) {
    if (this.isUnregisterLoading && (!rowsIds || rowsIds.length === 0)) {
      return;
    }

    this.selectedUnregisterIDs = rowsIds;
    this.MdtSelectionStore.set('unregisterStudents', rowsIds);
  }

  /*
   * Get student by ID
   * @param id {Number}
   * @return student {Object}
   */

  getStudentById(studentsList, id) {
    return _find(studentsList, item => {
      if (item.id === id) {
        return item;
      }
    });
  }

  getAttendace(attendanceList, id) {
    return _find(attendanceList, attendance => attendance.id === id);
  }

  /*
   * Register selected students
   * @param ev {Object}
   */

  registerSelected(ev) {
    if (this.selectedUnregisterIDs.length > 0) {
      this.registerStudents(this.selectedUnregisterIDs, ev);
    } else {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Zaznacz uczniów do zarejestrowania')
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }

  /*
   * Unregister selected students
   * @param ev {Object}
   */

  unregisterSelected(ev) {
    if (this.allStudents && this.selectedAllRegisterIDs.length > 0) {
      return this.closeAttendance(this.selectedAllRegisterIDs, ev);
    }

    if (this.selectedRegisterIDs.length > 0) {
      return this.closeAttendance(this.selectedRegisterIDs, ev);
    }

    this.$mdToast.show(
      this.$mdToast.simple()
        .textContent('Zaznacz uczniów do wyrejestrowania')
        .position('bottom right')
        .hideDelay(3000)
    );
  }

  confirmRemoveAttendance(ev) {
    const confirm = this.$mdDialog.confirm()
      .title('')
      .textContent('Czy na pewno chcesz usunąć rejestrację ucznia?')
      .ariaLabel('Czy na pewno chcesz usunąć rejestrację ucznia?')
      .targetEvent(ev)
      .ok('Usuń')
      .cancel('Anuluj');

    return this.$mdDialog.show(confirm);
  }

  removeAttendance(id, ev) {
    ev.stopPropagation();
    this.confirmRemoveAttendance(ev).then(() => {
      this.AttendanceService.destroy(id)
        .then(() => {
          this.loadPageCallbackWithDebounce();
          this.loadAllAttendances();
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Usunięto rejestrację')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  showInfo(id, ev) {
    ev.stopPropagation();
    let studentId = 0;
    const attendance = this.getAttendace(this.allAttendanceRegistrations, id);
    if (attendance) {
      studentId = attendance.student.id;
    } else {
      studentId = id;
    }

    this.StudentService.getInfo(studentId)
      .then(student => {
        this.$mdDialog.show({
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'StudentInfoController',
          locals: {student},
          template: studentInfoTemplate,
          disableParentScroll: true,
          clickOutsideToClose: true,
          targetEvent: ev
        });
      });
  }

  toggleHistoryAttendaces() {
    this.$mdSidenav('history-attendances').toggle();
  }

  toggleWaitingStudents() {
    this.$mdSidenav('waiting-students').toggle();
  }

  toggleStudents() {
    if (this.allStudents) {
      this.attendanceAllRegistrationsInterval = this.$interval(() => {
        this.loadAllAttendanceRegistration({showLoaderSpinner: false});
      }, 180000);
    } else {
      this.$interval.cancel(this.attendanceAllRegistrationsInterval);
    }
  }

  onRemoveWaitingStudents(response) {
    if (angular.isDefined(response)) {
      this.waitingStudentsNumber = response.length;
    }
  }

  hasPermittedToLeaveOnOwn(attendanceId) {
    const attendance = this.getAttendace(this.allAttendanceRegistrations, attendanceId);
    return get(attendance, 'student.isPermittedToLeaveOnOwn', false);
  }

  getStudentPermissionsScheduleByAttendanceId(attendanceId) {
    const list = this.getAttendace(this.allAttendanceRegistrations, attendanceId)?.student.permissionsScheduleToDisplay || [];
    return list.length > 0 ? `(${list.map(day => day.name + ' - ' + day.value).join(', ')})` : '';
  }

  affiliateToNonDefaultGroup(attendanceId) {
    const attendance = this.getAttendace(this.allAttendanceRegistrations, attendanceId);
    return !get(attendance, 'student.groupDefault', false);
  }

  enterPinCode(attendanceId, event) {
    const attendance = this.getAttendace(this.allAttendanceRegistrations, attendanceId);
    const student = get(attendance, 'student');
    event.stopPropagation();
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: '$ctrl',
      controller: PinRegistrationController,
      template: pinRegistrationTemplate,
      disableParentScroll: true,
      clickOutsideToClose: false,
      targetEvent: event,
      locals: {student}
    }).then(outsidePerson => {
      this.closeAttendance([attendanceId], event, {
        departureCategory: 3,
        comment: `Odebrano przez: ${outsidePerson.outsidePersonName} ${outsidePerson.outsidePersonLastName}`
      });
    });
  }

  authorizedOutsidePerson(attendanceId, event) {
    const attendance = this.getAttendace(this.allAttendanceRegistrations, attendanceId);
    const student = get(attendance, 'student');
    event.stopPropagation();
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: '$ctrl',
      controller: AuthorizedOutsidePersonController,
      template: authorizedOutsidePersonTemplate,
      disableParentScroll: true,
      clickOutsideToClose: false,
      targetEvent: event,
      locals: {student}
    }).then(outsidePerson => {
      this.closeAttendance([attendanceId], event, {
        departureCategory: 3,
        comment: `Odebrano przez: ${outsidePerson.outsidePersonName} ${outsidePerson.outsidePersonLastName}`
      });
    });
  }
}

export const Dashboard = {
  bindings: {
    currentClassRoom: '<',
    access: '<',
    classRooms: '<',
    me: '<',
    tags: '<'
  },
  template,
  controller: DashboardComponent
};
